/**
 * File: aria-search.js
 *
 * Import and initialize functions for search a11y fixes
 */

export default {
	results: document.querySelectorAll(".search-results .post_item"),
	init() {
		if (this.results.length > 0) {
			this.render();
		}

		this.handleSearchButtonAria();
	},
	handleSearchButtonAria() {
		const searchButtons = document.querySelectorAll(".search_submit");

		searchButtons.forEach((button) => {
			button.setAttribute("aria-label", "Search button");
		});

		// Search Modal close button.
		const searchClose = document.querySelector(".search_close");
		searchClose.setAttribute("aria-label", "Close Search");
		searchClose.setAttribute("tabindex", "0");
	},
	render() {
		// Link with same name fix
		const { results } = this;

		results.forEach((item) => {
			const title =
				item.querySelector(".post_title a").textContent.trim() ||
				item.querySelector(".post_title span").textContent.trim();
			const dateLink = item.querySelector(".post_date a");
			const date = dateLink.textContent.trim();

			dateLink.setAttribute("aria-label", `${date} ${title}`);
		});

		// ARIA hidden fix
		const hiddenItems = document.querySelectorAll('*[aria-hidden="true"]');

		hiddenItems.forEach((item) => {
			const children = item.querySelectorAll("*");

			item.setAttribute("tabindex", "-1");
			children.forEach((child) => child.setAttribute("aria-hidden", "true"));
			if (!item.classList.contains("menu-mobile")) {
				children.forEach((child) => child.setAttribute("tabindex", "-1"));
			}
		});

		// Focus on first article
		const skipContentLink = document.querySelector(
			".pojo-skip-link.pojo-skip-content"
		);
		if (skipContentLink !== null) {
			skipContentLink.setAttribute("tabindex", "0");
		}

		function setVoiceOverFocus(element) {
			var focusInterval = 20; // ms, time between function calls
			var focusTotalRepetitions = 100; // number of repetitions

			element.setAttribute("tabindex", "-1");
			element.blur();
			var focusRepetitions = 0;
			var interval = window.setInterval(function () {
				element.focus();
				focusRepetitions++;
				if (focusRepetitions >= focusTotalRepetitions) {
					window.clearInterval(interval);
				}
			}, focusInterval);
		}

		if (/\/ page\//.test(window.location.href)) {
			setVoiceOverFocus(results[0]);
		}
	},
};
